import {createFileRoute, notFound} from "@tanstack/react-router";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {ErrorComponent} from "../-errorComponent";
import {NotFoundComponent} from "../-notFoundComponent";
import {PendingComponent} from "../-pendingComponent";
import {
    getAuthenticationMethodsForUserWithCaching,
    getAuthenticationSessionsForUserWithCaching,
    getAuthenticationUserProfileWithCaching,
    getAuthenticationUserWithCaching,
} from "../-queries";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/authentication/$userId",
)({
    loader: async ({context, params}) => {
        const userIdResult = uuidZodValidator.safeParse(params.userId);
        if (userIdResult.success !== true) {
            throw notFound();
        }

        const userId = userIdResult.data;

        let user;
        try {
            user = await getAuthenticationUserWithCaching({
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                userId,
            });
        } catch (error) {
            if (error instanceof Error && error.message === "404") {
                throw notFound();
            }
            throw error;
        }

        const [authMethods, sessions, userProfile] = await Promise.all([
            getAuthenticationMethodsForUserWithCaching({
                queryClient: context.queryClient,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                userId,
            }),
            getAuthenticationSessionsForUserWithCaching({
                queryClient: context.queryClient,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                userId,
            }),
            getAuthenticationUserProfileWithCaching({
                queryClient: context.queryClient,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                userId,
            }),
        ]);

        return {
            user,
            userId,
            userProfile,
            authMethods,
            sessions,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
